export function isCmsPath(path) {
  return path.includes('cms');
}